// 渠道检测优先级：域名 > env（dev 兜底） > 默认 com
// - 精确匹配主域 xiaowuchuhaitong.cn / xiaowuchuhaitong.com，含其任意子域
// - localhost / IP / 其他域名：由 VUE_APP_CHANNEL 兜底（dev:cn 用）
// - 都没命中：默认 com
const PROD_CN = 'xiaowuchuhaitong.cn'
const PROD_COM = 'xiaowuchuhaitong.com'

const envChannel = process.env.VUE_APP_CHANNEL
const host = (typeof window !== 'undefined' && window.location && window.location.hostname)
  ? window.location.hostname.toLowerCase()
  : ''

function matchHost(target) {
  return host === target || host.endsWith('.' + target)
}

function detectChannel() {
  if (matchHost(PROD_CN)) return 'cn'
  if (matchHost(PROD_COM)) return 'com'
  if (envChannel === 'cn') return 'cn'
  return 'com'
}

export const CHANNEL = detectChannel()
export const isCN = CHANNEL === 'cn'
